<template>
  <card-component title="Edit Profile" icon="account-circle">
    <form>
      <!-- <b-field horizontal label="Avatar">
        <div v-if="form.photoUrl" class="container">
          <img class="avatar" :src="form.photoUrl" alt />
        </div>
        <b-field class="field">
          <b-upload v-model="file" @input="upload" accept="image/*">
            <a class="button is-primary">
              <b-icon icon="upload" custom-size="default"></b-icon>
              <span>{{ buttonLabel }}</span>
            </a>
          </b-upload>
        </b-field>

        <progress
          v-if="uploadPercent > 0"
          class="progress is-primary"
          :value="uploadPercent"
          max="100"
        >{{uploadPercent}}%</progress>
      </b-field> -->
      <b-field horizontal label="Name" message="Required. Your name">
        <b-input v-model="form.name" name="name" required />
      </b-field>
      <b-field horizontal label="E-mail" message="Required. Your e-mail">
        <b-input v-model="form.email" name="email" type="email" required />
      </b-field>
       <b-field horizontal label="Code No." message="Required. Your Code No.">
        <b-input v-model="form.code_no" name="code_no" required />
      </b-field>
       <b-field horizontal label="Office Code No." message="Required. Your Office Code No.">
        <b-input v-model="form.office_code_no" name="office_code_no"  required />
      </b-field>
      <b-field horizontal label="Designation">
        <b-input v-model="form.designation" name="designation"  />
      </b-field>
      <b-field horizontal label="Contact Number">
        <b-input v-model="form.contact_number" name="contact_number"  />
      </b-field>
      <b-field horizontal label="Profile Photo" message="">
        <b-upload v-model="photoScan" @input="upload" accept="image/*">
            <a class="button is-primary">
              <b-icon icon="upload" custom-size="default"></b-icon>
              <span>{{ formPhotoLabel }}</span>
            </a>
        </b-upload>
      </b-field>
                                      <span class="file-name" v-if="photoScan">{{ photoScan.name }}</span>
      <hr />
      <b-field horizontal>
        <!-- <div class="control">
          <button type="submit" class="button is-primary" :class="{'is-loading':isLoading}">
            Submit
          </button>
        </div>-->
        <button
          @click.prevent="updateAuthUserPressed"
          :disabled="isUploading"
          class="button is-success"
        >Save changes</button>
        <button @click="cancel" class="button">Cancel</button>
      </b-field>
    </form>
  </card-component>
</template>

<script>
import { mapState } from 'vuex';
// import FilePicker from '@/components/FilePicker'
import CardComponent from '@/components/CardComponent';
import axiosInstance from '../services/axios';
import {
  required,
  email,
  // role,
  code_no,
  office_code_no,
  photoUrl,
  minLength,
  url,
  sameAs,
} from 'vuelidate/lib/validators';
import { getAPIEndpoint } from '../helpers';
export default {
  name: 'ProfileUpdateForm',
  components: {
    CardComponent,
  },
  data() {
    return {
      // isFileUploaded: false,
      // isLoading: false,
      uploadPercent: 0,
      isUploading: false,
      file: null,
      photoScan: null,
      form: {
        name: '',
        email: '',
        // role:'',
        code_no: '',
        office_code_no: '',
        designation: '',
        contact_number:'',
        photoUrl: '',
      },
    };
  },
  validators: {
    form: {
      name: {
        required,
        name,
      },
      email: {
        required,
        email,
      },
      // role: {
      //   required,
      //   role,
      // },
      code_no: {
        required,
        code_no,
      },
      designation: {
        // required,
      },
        contact_number: {
        // required,
      },
      office_code_no: {
        required,
        office_code_no,
      },
      photoUrl: {
        // required,
        photoUrl,
      },
    },
  },
  // props: {
  // authUser: {
  //   type: Object,
  //   required: true
  // }
  // },
  created() {
    this.form.name = this.$store.state.auth.user.name;
    this.form.email = this.$store.state.auth.user.email;
    // this.form.role = this.$store.state.auth.user.role;
    this.form.code_no = this.$store.state.auth.user.code_no;
    this.form.office_code_no = this.$store.state.auth.user.office_code_no;
    this.form.photoUrl = this.$store.state.auth.user.photoUrl;
    this.form.designation = this.$store.state.auth.user.designation;
    this.form.contact_number = this.$store.state.auth.user.contact_number;
  },
  computed: {
    // ...mapState([
    //   'userName',
    //   'userEmail'
    // ]),
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
    formPhotoLabel() {
      return !this.photoScan ? 'Upload Photo' : 'Another Photo';
    },
    // buttonLabel() {
    //   return !this.file ? 'Pick a file' : 'Pick another file';
    // },
  },
  // mounted () {
  //   this.form.name = this.userName
  //   this.form.email = this.userEmail
  // },
  methods: {
    updateAuthUserPressed() {
      // console.log(this.form);
      // this.$v.form.$touch();

      this.$store
        .dispatch('auth/updateAuthUser', this.form)
        .then(() => {
          this.$buefy.snackbar.open({
            message: 'Profile Updated Successfully',
            queue: false,
          });
          this.$root.$emit(
            'userProfileUpdated',
            this.form.name,
            this.form.email,
            // this.form.role,
            this.form.code_no,
            this.form.office_code_no,
            this.form.photoUrl,
            this.form.designation,
            this.form.contact_number
          );
        })
        .catch((err) => {
          // console.log(err);
          this.$buefy.snackbar.open({
            message: `Something went wrong`,
            queue: false,
          });
        });
    },
    upload(file) {
      this.isUploading = true;
      this.$emit('input', file);
      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', file);

      axiosInstance
        .post(`${getAPIEndpoint()}/citizens/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.photoUrl = res.data.imageUrl;
          this.isUploading = false;
        })
        .catch((err) => {
          this.isUploading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
    progressEvent(progressEvent) {
      this.uploadPercent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
    },
    cancel() {
      this.$emit('cancel');
    },
    // submit () {
    //   this.isLoading = true
    //   setTimeout(() => {
    //     this.isLoading = false
    //     this.$store.commit('user', this.form)
    //     this.$buefy.snackbar.open({
    //       message: 'Updated',
    //       queue: false
    //     })
    //   }, 500)
    // }
  },
  watch: {
    userName(newValue) {
      this.form.name = newValue;
    },
    userEmail(newValue) {
      this.form.email = newValue;
    },
  },
};
</script>
